import type { Org } from '@/types';
import RadioGroup from '@nautilusbio/nb-design-system/RadioGroup';
import React, { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import useSwitchOrganization from '../hooks/useSwitchOrganization';

const SelectionCellRenderer: FC<{ data: Org }> = ({ data }) => {
  const { t } = useTranslation('orgs');

  const { handleChange, isSelected } = useSwitchOrganization(data);

  return (
    <RadioGroup
      aria-label={t('select_organization', { name: data.name })}
      data-testid={`org-select-${data.id}`}
      id={`org-select-${data.id}`}
      label=""
      onChange={() => handleChange(false)}
      options={[{ children: '', value: data.id }]}
      size="sm"
      value={isSelected ? data.id : ''}
    />
  );
};

export default memo(SelectionCellRenderer);
